// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__575vP","footer":"styles_footer__3tjHW"};